import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { LocationInfo, LocationOverview, RentalInfo } from 't4core';
import { BookingOverviewComponent } from '../../components/bookingOverview/bookingOverview';
import { FindBookingDialog } from '../../dialogs/findBookingDialog/findBookingDialog';
import { PageBase } from 't4core';
import { RentalDialog, NearbyOneWayAvailabilityDialog } from '../../../../t4common';


declare var MarkerClusterer: any;

@Component({
    styleUrls: ['./bookings.css'],
    selector: 'bookings',
    templateUrl: './bookings.component.html',
})
export class BookingsComponent extends PageBase implements OnInit {

    constructor(el: ElementRef) {
        super(el, "OneWayAdmin");
    }

    // Map
    @ViewChild('locationOverview', {static: false}) overview: BookingOverviewComponent;

    // Data
    private overviewData: LocationOverview[] = [];


    // View data
    public weeks = [];
    public selectedWeek: number = 201848;
    public get year(): string {
        return this.selectedWeek.toString().substring(0, 4);
    }

    public get week(): string {
        return this.selectedWeek.toString().substring(4);
    }

    public selectedLocation: LocationInfo = new LocationInfo();
    public bookingQueue: RentalInfo[] = [];


    async ngOnInit() {
        this.weeks = await this.Api.get<number[]>('Util/GetWeeks', { n: 10 });
        this.selectedWeek = this.weeks[0];
        this.overview.refresh();
    }

    public async newBooking(locationId: number = this.Settings.clientSettings.RentalLocationId, typeId: number = 340) {
        var dlg = await RentalDialog.newBooking(this.Dialog, {
                isOneWay: true,
                pickupLocationId: locationId,
                returnLocationId: this.Settings.clientSettings.RentalLocationId,
                typeId: typeId,
            }, this.Settings);

            this.overview.refresh();
    }

    public findBooking() {
        var dlg = this.Dialog.open(FindBookingDialog, {});
    }

    public async findNearby() {
        var ret = await this.Dialog.open(NearbyOneWayAvailabilityDialog, { data: { locationId: this.Settings.clientSettings.RentalLocationId, selectedLocationId: this.Settings.clientSettings.RentalLocationId, selectedTypeId: 340, isWebBooking: false } }).afterClosed().toPromise();
        if (ret) {
            this.newBooking(ret.locationId, ret.typeId);
        }
    }

    public prev() {
        var index = this.weeks.indexOf(this.selectedWeek);
        if (index - 1 < 0) return;

        this.selectedWeek = this.weeks[index - 1];
    }

    public next() {
        var index = this.weeks.indexOf(this.selectedWeek);
        if (index + 1 >= this.weeks.length) return;

        this.selectedWeek = this.weeks[index + 1];
    }
}
